<template>
	<div v-show="visible && point" class="click-center" :style="style">
		<div class="center-marker"></div>
		<div class="pulse" :key="animationKey"></div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue"

const props = defineProps<{
	point: { x: number; y: number } | null
	visible: boolean
	animationKey: number
}>()

const style = computed(() =>
	props.point
		? {
				left: `${props.point.x}px`,
				top: `${props.point.y}px`,
			}
		: {}
)
</script>

<style scoped>
.click-center {
	position: absolute;
	pointer-events: none;
	z-index: 5;
}

.center-marker {
	background-color: var(--neutral-100);
	border: var(--border-width-thick) solid var(--neutral-100);
	border-radius: 50%;
	position: absolute;
	transform: translate(-50%, -50%);
	width: var(--spacing-sm);
	height: var(--spacing-sm);
}

.pulse {
	position: absolute;
	height: 36px;
	width: 36px;
	left: 50%;
	top: 50%;
	opacity: 0;
	border: var(--border-width-base) solid var(--neutral-100);
	border-radius: var(--border-radius-2xl);
	transform: translate(-50%, -50%);
	animation: pulsate 1s ease-out infinite;
}

@keyframes pulsate {
	0% {
		transform: translate(-50%, -50%) scale(0.1);
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		transform: translate(-50%, -50%) scale(1.2);
		opacity: 0;
	}
}
</style>
